export enum InvoiceStatus {
    Created = 0,
    Published = 1
}

export const InvoiceStatusMetadata = {
    '0': {
        display: 'Created',
        value: 0
    },
    '1': {
        display: 'Published',
        value: 2
    }
};
